import { useViewContext } from "@editor-providers";
import { useEffect, useRef, useState } from "react";
import { isStatic } from "@/shared";

export const useElementOnScreen = (options: any, animate = true) => {
  const containerRef: any = useRef(null);
  const [key, setKey] = useState(0);
  const { view } = useViewContext();
  const isPdf = view === "pdf";
  const staticView = isStatic();

  useEffect(() => {
    const { current: container } = containerRef;
    const observer = new IntersectionObserver((entries: any) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setKey((val) => val + 1);
        observer.unobserve(container);
      }
    }, options);
    if (container) observer.observe(container);

    return () => {
      if (container) observer.unobserve(container);
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !isPdf && !staticView && animate
    ? [containerRef, key, setKey]
    : [containerRef, 1, () => setKey(1)];
};
